import { useEffect, useState } from "react";
import { useExchangeRate } from "../../hooks/useExchangeRate";
import talmaLogo from "../../images/talmaclick_logo.png";
import { logout } from "../../utils/authUtils";
import AppSidebar from "./AppSidebar";
import { GlobalContainer, ScreenContainer } from "./InitialLayoutStyles";
import MenuBar from "./Menubar";

const BREAKPOINT = "1100px";
const matchedMedia = window.matchMedia(`(min-width: ${BREAKPOINT})`);

function InitialLayout(props: any) {
  const { children, isAdmin, userInfo, updateLogged } = props;
  const onLogout = () => {
    logout();
    updateLogged(false);
  };
  const [isBigScreen, setIsBigScreen] = useState(matchedMedia.matches);
  useEffect(() => {
    const onMediaChange = (e: any) => setIsBigScreen(e.matches);
    matchedMedia.addEventListener("change", onMediaChange);
    return () => matchedMedia.removeEventListener("change", onMediaChange);
  }, []);

  const exchangeRate = useExchangeRate();
  const sidebarContent = (
    <AppSidebar
      isAdmin={isAdmin}
      imageSrc={talmaLogo}
      exchangeRate={exchangeRate}
      userInfo={userInfo}
      onLogout={onLogout}
    />
  );
  return (
    <GlobalContainer maxWidth={BREAKPOINT}>
      {isBigScreen ? (
        sidebarContent
      ) : (
        <MenuBar imageSrc={talmaLogo} header={userInfo.agentName}>
          {sidebarContent}
        </MenuBar>
      )}
      <ScreenContainer>{children}</ScreenContainer>
    </GlobalContainer>
  );
}

export default InitialLayout;
